import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Alert } from 'reactstrap';

export default class ContractPhaseOverageWarning extends React.Component {
    exceedsBidTotal = (entityContractPhase, contractPhases) => {
        const contractPhase = contractPhases.find(
            (cp) => cp.id == entityContractPhase.contractPhaseId
        );

        if (!contractPhase) {
            return false;
        }

        const bidTotal = Number(contractPhase.quantity);

        const scheduledTotal =
            Number(contractPhase.scheduledQuantity) +
            Number(entityContractPhase.targetQuantity);

        return scheduledTotal > bidTotal;
    };

    getNumericDisplay = (quantity, contractPhase) => {
        const isLumpSum = contractPhase.unitOfMeasure === 'LS';

        return isLumpSum
            ? `${Number(quantity) * 100}% ${contractPhase.unitOfMeasure}`
            : `${quantity} ${contractPhase.unitOfMeasure}`;
    };

    render() {
        const { entityContractPhases, contractPhases } = this.props;

        if (
            !entityContractPhases ||
            !entityContractPhases.length ||
            !contractPhases ||
            !contractPhases.length
        ) {
            return null;
        }

        const phasesExceedingTotal = entityContractPhases.filter((ecp) =>
            this.exceedsBidTotal(ecp, contractPhases)
        );

        if (!phasesExceedingTotal || !phasesExceedingTotal.length) {
            return null;
        }

        return (
            <Alert color="warning" fade={false}>
                <div className="d-flex">
                    <div>
                        <FontAwesomeIcon
                            icon={faExclamationCircle}
                            className="mr-3"
                        />
                    </div>
                    <div>
                        <strong>
                            The following phases have overages on their bid
                            estimates.
                        </strong>
                        {phasesExceedingTotal.map((ecp) => {
                            const contractPhase = contractPhases.find(
                                (cp) => cp.id == ecp.contractPhaseId
                            );

                            if (!contractPhase) {
                                return null;
                            }

                            let totalScheduledAmount =
                                Number(contractPhase.scheduledQuantity) +
                                Number(ecp.targetQuantity);

                            const scheduledDisplay = this.getNumericDisplay(
                                totalScheduledAmount,
                                contractPhase
                            );
                            const bidDisplay = this.getNumericDisplay(
                                contractPhase.quantity,
                                contractPhase
                            );

                            return (
                                <div key={ecp.contractPhaseId}>
                                    {contractPhase.displayPhase} (
                                    {contractPhase.description}) has a total of{' '}
                                    {scheduledDisplay} scheduled. The bid
                                    originally called for {bidDisplay}.
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Alert>
        );
    }
}
